module.exports = __webpack_public_path__ + "static/img/backgnd.97ec086a.jpg";